const initial = {
  events: [
    {
      id: "",
      name: "",
      description: "",
    },
  ],
};

// Actions
export const addEvents = (events) => ({
  type: "ADD_EVENTS",
  payload: events,
});

// Reducer
const Events = (state = initial, action) => {
  switch (action.type) {
    case "ADD_EVENTS":
      return {
        ...state,
        events: [...state.events, action.payload],
      };

    default:
      return state;
  }
};

export default Events;
